import {
	CPM_ENABLING_CHECKS
} from '../actions/CPMFilesUploadActions.js';

const initialState = {
	remove: []
};

const CPMFilesUploadReducer = (state = initialState, action) => {
	switch (action.type) {
					case CPM_ENABLING_CHECKS: {
						return {
							...state,
							remove: action.remove
						};
					}
					default: {
						return state;
					}
	}
};

export default CPMFilesUploadReducer;
